export default "assets/logo-b7ddc3ec.svg";